// extracted by mini-css-extract-plugin
module.exports = {"sectionReasons":"SectionReasons_sectionReasons__FuVgJ","listOfReasons":"SectionReasons_listOfReasons__21UjZ"};